/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Tl_Target_ChangedInputs */

const en_tl_target_changed = /** @type {(inputs: Tl_Target_ChangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Target date of ${i?.name} changed`)
};

const de_tl_target_changed = /** @type {(inputs: Tl_Target_ChangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zieldatum von ${i?.name} geändert`)
};

/**
* | output |
* | --- |
* | "Target date of {name} changed" |
*
* @param {Tl_Target_ChangedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_target_changed = /** @type {((inputs: Tl_Target_ChangedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Target_ChangedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_target_changed(inputs)
	return en_tl_target_changed(inputs)
});